import * as React from 'react';
import PropTypes from 'prop-types';

const SvgNavigationTrainingNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M17.66 2.33a2.162 2.162 0 00-2.16-2h-7a2.162 2.162 0 00-2.16 2H2.33v21.34h19.34V2.33zm-9.99.17a.985.985 0 01.02-.17.818.818 0 01.81-.66h7a.818.818 0 01.81.66.982.982 0 01.02.17v1.83H7.67zm12.66 19.83H3.67V3.67h2.66v2h11.34v-2h2.66z" />
        <path d="M8.675 16h-1.35v4h1.35zm4-4h-1.35v8h1.35zm4-4h-1.35v12h1.35z" />
      </g>
    </svg>
  )
);
SvgNavigationTrainingNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgNavigationTrainingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgNavigationTrainingNormalSmall;
